module.exports = __webpack_public_path__ + "img/45.94f6c3e0.jpg";